<template>
  <div
    @contextmenu="selectComponentDEV($event, schema.model)"
    :class="['d-flex', getSelectedDEV && 'dev-selected-component']"
    :key="generateId(schema.model)"
  >
    <i4pro-icon-popover
      v-if="schema.attributesInfo"
      :class="[schema.attributesInfo.right ? 'ml-1 order-2' : 'mr-1']"
      :schema="schema"
      :model="model"
    ></i4pro-icon-popover>

    <v-select
      :name="schema.model"
      :id="generateId(schema.model)"
      :value="schema.value"
      :rules="rules"
      v-model="value"
      @blur="onBlur"
      @change="onChange"
      @focus="onFocus"
      @input="onInput"
      @click:clear="clear()"
      v-bind="schema.attributesSelect"
      :disabled="schema.readonly"
      class="input-group--focused"
    >
      <template v-slot:label>
        {{ schema.attributesSelect.label }}
        <span v-if="schema.rules.includes('required')" class="red--text">*</span>
      </template>
    </v-select>
  </div>
</template>

<script>
import { abstractField } from 'vue-form-generator';
import devComponentMixin from '@/mixins/dev-component-mixin';
import rulesMixin from '@/mixins/rules-mixin';
import inputEventsMixin from '@/mixins/input-events-mixin';
import componentMixin from '@/mixins/component-mixin';

export default {
  mixins: [abstractField, devComponentMixin, rulesMixin, inputEventsMixin, componentMixin],

  components: {
    i4proIconPopover: () => import('@/components/icons/i4pro-icon-popover')
  },

  created() {
    if (this.schema.attributesSelect.multiple && this.value && this.value.length) {
      if (typeof this.value === 'string') {
        this.value = JSON.parse(this.value);
      }
    }
  },

  methods: {
    // Função removido pois é simulado pelo watch value abaixo. onChange é executado só com alteração do usuário
    // e a função this.changeEvents também precisa ser chamada quando há alteração o v-model pelo sistema.
    // Exemplo um field tem o atributo fill para altera o valor deste select.
    // Se esse onchange for ativado quando o usuário alterar o valor o this.changeEvents será chamado duas vezes causando problemas.
    // onChange: async function () {
    //   this.changeEvents();
    // },

    clear() {
      this.$nextTick(() => (this.model[this.schema.model] = ''));
    },
  },

  watch: {
     async value(val, oldVal) {
      if (Array.isArray(val) && val.length > this.schema.max) {
        this.$nextTick(() => this.value.pop());
      }
      if (this.schema.attributesSelect.multiple && val) this.value = Array.isArray(val) ? val : JSON.parse(val);

      if ((Array.isArray(val) == false && val !== oldVal) || (Array.isArray(val) && val.length != oldVal.length)) {
        await this.changeEvents();
      }
    }
  }
};
</script>
